import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as actions from '../../store/actions/churgerBuilderActions';
import * as s from '../../components/ChurgerBuilder/ChurgerImgRefs/ChurgerSVGRefs';

export default function Bamhurger() {
	const dispatch = useDispatch();

	const drawer = useSelector((state) => {
		return state.drawer;
	});

	const clickHandler = () => {
		dispatch(actions.setDrawer(true));
		dispatch(actions.setFXPlaying('crunchApple'));
	};

	const style = drawer ? 'none' : ' ';

	return (
		<div id="Bamhurger" onClick={clickHandler} style={{ display: style }}>
			<img className="BamhurgerIng" src={s.sesameBottom} alt="bun" />
			<img className="BamhurgerIng" src={s.redMeat} alt="meat" />
			<img className="BamhurgerIng" src={s.sesameTop} alt="bun" />
		</div>
	);
}
